import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  // Sidebar state
  isCollapsed = signal(false);

  // Theme state
  isDarkMode = signal(false);
  isMobileOpen = signal(false);

  checkScreenSize(width: number) {
    if (width < 768) {
      // Mobile: Sidebar handled by Drawer/Overlay, reset states
      this.isCollapsed.set(false);
      this.isMobileOpen.set(false);
    } else if (width >= 768 && width <= 1100) {
      // Tablet: Auto-collapse
      this.isCollapsed.set(true);
    } else {
      // Desktop: Auto-expand
      this.isCollapsed.set(false);
    }
  }

  toggleCollapse() {
    this.isCollapsed.update(state => !state);
  }

  toggleMobile() {
    this.isMobileOpen.update(state => !state);
  }

  toggleTheme() {
    this.isDarkMode.update(state => !state);
    const htmlTag = document.documentElement;
    if (this.isDarkMode()) {
      htmlTag.classList.add('dark');
    } else {
      htmlTag.classList.remove('dark');
    }
  }


}
